export const filters = {
  blue: 'filter: invert(27%) sepia(69%) saturate(2559%) hue-rotate(215deg) brightness(99%) contrast(96%);',
  green:
    'filter: invert(86%) sepia(35%) saturate(711%) hue-rotate(25deg) brightness(105%) contrast(95%);',
  violet:
    'filter: invert(28%) sepia(36%) saturate(5075%) hue-rotate(251deg) brightness(93%) contrast(108%);',
  yellow:
    'filter: invert(85%) sepia(35%) saturate(951%) hue-rotate(343deg) brightness(99%) contrast(106%);',
};
